import { Grid } from '@mui/material';
import '../healthoverview.css';
const HealthStatBox = ({ title, value }) => {
  return (
    <>
      <Grid className="health-box">
        <small>{title}</small>
        <span className="bold">{value}</span>
      </Grid>
    </>
  );
};

export default HealthStatBox;
